function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled, css } from 'styled-components';
import { Text } from '../Text';
import { StateLayer } from '../../core-components';
export const StyledActionCard = styled.button.withConfig({
  componentId: "aui__sc-i9haav-0"
})(["all:unset;box-sizing:border-box;width:100%;cursor:pointer;position:relative;overflow:hidden;display:flex;flex-direction:row;align-items:stretch;gap:var(--aui-spacing-100);--border-inset:0px;padding:calc(var(--aui-spacing-100) - var(--border-inset)) calc(var(--aui-spacing-200) - var(--border-inset));border-radius:var(--aui-border-radius-100);border:calc(var(--aui-stroke-card) + var(--border-inset)) solid var(--aui-outline);background-color:var(--aui-surface);color:var(--aui-on-surface);", " &:focus-visible,&:has(:focus-visible){outline-offset:4px;outline:5px auto blue;outline:5px auto -webkit-focus-ring-color;}", " ", ";", ";"], ({
  $state
}) => $state === 'enabled' && css(["&:hover{--border-inset:0px;border-color:var(--aui-on-surface-soft);> ", "{opacity:var(--aui-state-layer-hover);}}&:active{--border-inset:0px;border-color:var(--aui-on-surface-soft);box-shadow:2px 2px 8px 4px var(--aui-fills-cards-pressed-shadow) inset;> ", "{opacity:var(--aui-state-layer-press);}}"], StateLayer, StateLayer), ({
  $isSelected,
  $state
}) => $isSelected && $state !== 'disabled' && $state !== 'readonly' && css(["--border-inset:var(--aui-stroke-card);&:hover{--border-inset:var(--aui-stroke-card);}"]), ({
  $isSelected
}) => $isSelected && css(["border-color:var(--aui-on-surface);&:hover{border-color:var(--aui-on-surface);}"]), ({
  $state
}) => handleState($state));
const handleState = state => {
  if (state === 'disabled') {
    return css(["cursor:not-allowed;> *{opacity:var(--aui-state-layer-on-disabled);}> ", "{opacity:var(--aui-state-layer-disabled);}"], StateLayer);
  } else if (state === 'readonly') {
    return css(["> *{opacity:var(--aui-state-layer-on-read-only);}> ", "{opacity:var(--aui-state-layer-read-only);}"], StateLayer);
  }
};
export const CardContent = styled.div.withConfig({
  componentId: "aui__sc-i9haav-1"
})(["flex-grow:1;display:flex;flex-direction:column;justify-content:flex-start;gap:var(--aui-spacing-050);padding:var(--aui-spacing-100) 0;"]);
export const Leading = styled.div.withConfig({
  componentId: "aui__sc-i9haav-2"
})(["flex-shrink:0;display:flex;align-items:center;img,picture{object-fit:contain;}&:has([data-aui='icon']){align-items:flex-start;padding-top:0.375rem;}"]);
export const Trailing = styled.div.withConfig({
  componentId: "aui__sc-i9haav-3"
})(["flex-shrink:0;display:flex;align-items:center;img,picture{object-fit:contain;}"]);
export const Heading = props => /*#__PURE__*/React.createElement(Text, _extends({
  lineHeight: 1.3,
  size: 2
}, props));
export const SupportiveText = props => /*#__PURE__*/React.createElement(Text, _extends({
  lineHeight: 1.3,
  size: 1,
  color: "var(--aui-on-surface-soft)"
}, props));
export const ToggleWrapper = styled.div.withConfig({
  componentId: "aui__sc-i9haav-4"
})(["margin:var(--aui-spacing-100) -6px 0 2px;"]);